var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$vuetify.breakpoint.smAndDown)?_c('home-smartphone-template',{attrs:{"links":_vm.links}},[_vm._t("default")],2):_c('home-pc-template',{attrs:{"links":_vm.links}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }